// src/helpers/rutaProveedores.js
import axios from "axios";

// SIN slash final
// DANLU usa React Scripts, por eso uso process.env y no import.meta.env
const RAW_BASE_URL =
  process.env.REACT_APP_API_BASE || "https://backdanlu.eu-4.evennode.com";

const BASE_URL = String(RAW_BASE_URL).replace(/\/+$/, "");

const API = axios.create({
  baseURL: BASE_URL,
});

// Arma paths sin doble slash
const p = (s) => String(s || "").replace(/^\/+/, "");

// Headers con token si existe
const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

// DEBUG: ver URL efectiva
const debugUrl = (url) => {
  console.log("👉 URL:", API.getUri({ url }));
};

// ---- PROVEEDORES ----

// ✅ Traer todos los proveedores
export const getProveedores = async () => {
  const url = p("proveedores");
  debugUrl(url);

  try {
    const { data } = await API.get(url, auth());

    // Normaliza:
    // back puede devolver { ok:true, proveedores:[...] }
    // o array directo
    return Array.isArray(data?.proveedores)
      ? data.proveedores
      : Array.isArray(data)
      ? data
      : [];
  } catch (error) {
    console.error("❌ Error getProveedores:", error.response?.data || error);

    return [];
  }
};

// ✅ Traer proveedor por ID
export const getProveedorById = async (id) => {
  const url = p(`proveedores/${id}`);
  debugUrl(url);

  try {
    const { data } = await API.get(url, auth());
    return data;
  } catch (error) {
    console.error("❌ Error getProveedorById:", error.response?.data || error);

    return {
      ok: false,
      error: error.response?.data || "Error al obtener proveedor",
    };
  }
};

// Alias por compatibilidad con componentes viejos
export const getProveedorId = getProveedorById;

// ✅ Crear proveedor
export const postProveedor = async (payload) => {
  const url = p("proveedores");
  debugUrl(url);

  try {
    const { data } = await API.post(url, payload, auth());
    return data;
  } catch (error) {
    console.error("❌ Error postProveedor:", error.response?.data || error);

    return {
      ok: false,
      error: error.response?.data || "Error al crear proveedor",
    };
  }
};

// Alias por compatibilidad con componentes viejos
export const addProveedor = postProveedor;

// ✅ Modificar proveedor
export const putProveedor = async (id, payload) => {
  const url = p(`proveedores/${id}`);
  debugUrl(url);

  try {
    const { data } = await API.put(url, payload, auth());
    return data;
  } catch (error) {
    console.error("❌ Error putProveedor:", error.response?.data || error);

    return {
      ok: false,
      error: error.response?.data || "Error al modificar proveedor",
    };
  }
};

// Alias por compatibilidad con componentes viejos
export const modifProveedor = async (datos, id) => {
  return putProveedor(id, datos);
};

// ✅ Eliminar / desactivar proveedor
export const deleteProveedor = async (id) => {
  const url = p(`proveedores/${id}`);
  debugUrl(url);

  try {
    const { data } = await API.delete(url, auth());
    return data;
  } catch (error) {
    console.error("❌ Error deleteProveedor:", error.response?.data || error);

    return {
      ok: false,
      error: error.response?.data || "Error al eliminar proveedor",
    };
  }
};

// Alias por compatibilidad con componentes viejos
export const delProveedor = deleteProveedor;